import { useLocation } from "react-router-dom";
import ImageHeading from "../components/ui/ImageHeading";

const LifeAtZumsDetail = () => {
  const location = useLocation();

  // Get data passed via state
  const section = location.state;

  if (!section) {
    return <div className="text-center py-20">Section not found!</div>;
  }

  // Use the first image as header or fallback to a placeholder
  const headerImage = section.gallery_url[0] || "/placeholder.svg";

  return (
    <div>
      <ImageHeading heading="Life At ZUMS" imageUrl={headerImage} />
      <div className="min-h-screen container mx-auto px-4 md:px-8 ">
        <h1 className="text-3xl font-bold mb-4">{section.title}</h1>
        <p className="mb-8">{section.description}</p>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {section.gallery_url.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`${section.title}-${index}`}
              className="w-full h-48 object-cover rounded-md shadow-md"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LifeAtZumsDetail;
